// Debug utility for testing useUserId hook functionality
export const debugAccessToken = () => {
  const accessToken = localStorage.getItem("accessToken");
  console.log("=== DEBUG ACCESS TOKEN ===");
  console.log("Raw token exists:", !!accessToken);
  
  if (!accessToken) {
    console.log("No access token found in localStorage");
    return null;
  }
  
  console.log("Token length:", accessToken.length);
  console.log("Token preview:", accessToken.substring(0, 50) + "...");
  
  try {
    // Parse JWT manually
    const parts = accessToken.split(".");
    console.log("Token parts count:", parts.length);
    
    if (parts.length !== 3) {
      console.error("Invalid JWT format - should have 3 parts separated by dots");
      return null;
    }
    
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    
    const decoded = JSON.parse(jsonPayload);
    console.log("Decoded token payload:", decoded);
    
    const userInfo = {
      userId: decoded.user_id,
      role: decoded.role,
      exp: decoded.exp,
      isExpired: decoded.exp ? Date.now() / 1000 > decoded.exp : false
    };
    
    console.log("Extracted user info:", userInfo);
    
    if (userInfo.isExpired) {
      console.warn("Token is expired!");
    }
    
    return userInfo;
    
  } catch (error) {
    console.error("Error parsing JWT token:", error);
    return null;
  }
};

// Check if token needs refresh
export const checkTokenValidity = () => {
  const userInfo = debugAccessToken();
  
  if (!userInfo) {
    return { valid: false, reason: "No valid token" };
  }
  
  if (userInfo.isExpired) {
    return { valid: false, reason: "Token expired" };
  }
  
  if (!userInfo.userId) {
    return { valid: false, reason: "Missing user_id in token" };
  }
  
  return { valid: true, userInfo };
};

// Force refresh hook state (call this after login)
export const notifyTokenChanged = () => {
  window.dispatchEvent(new Event("auth-token-changed"));
};